import createIcon from '../../createIcon';

/**
 * @component @name ViewDay
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi41IDIxSDIxLjVWMThIMi41VjIxWk0yMC41IDhIMy41QzIuOTUgOCAyLjUgOC40NSAyLjUgOVYxNUMyLjUgMTUuNTUgMi45NSAxNiAzLjUgMTZIMjAuNUMyMS4wNSAxNiAyMS41IDE1LjU1IDIxLjUgMTVWOUMyMS41IDguNDUgMjEuMDUgOCAyMC41IDhaTTIuNSAzVjZIMjEuNVYzSDIuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ViewDay = createIcon('ViewDay', [
  [
    'path',
    {
      d: 'M2.5 21H21.5V18H2.5V21ZM20.5 8H3.5C2.95 8 2.5 8.45 2.5 9V15C2.5 15.55 2.95 16 3.5 16H20.5C21.05 16 21.5 15.55 21.5 15V9C21.5 8.45 21.05 8 20.5 8ZM2.5 3V6H21.5V3H2.5Z',
      key: '6ymb8j',
    },
  ],
]);

export default ViewDay;
